import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  cfiHeaderLinks = [
    {
      id: 'cfi_certifications',
      label: this._language.selectTranslate('directory_corporatefinance_org.header.certifications'),
      externalLink:
        'https://corporatefinance.org/certifications/fmva-financial-modeling-certification',
    },
  ];

  constructor(private _language: AccredibleLanguageService) {}
}
